<template>
    <van-popup
        v-model="showPop"
        closeable
        close-icon="https://file.40017.cn/appresource/image/forStudent/new/icon_closed@2x.png"
        position="bottom"
        class="rule-popup-box"
        @close="closePop">
        <div class="title-popup">{{title}}</div>
        <div class="cont-box">
            <div class="top">
                <p class="tip">恭喜解锁以下权益</p>
                <div class="list-box">
                    <template v-for="(item, index) in data">
                        <div class="item-box" v-if="!isChsiAuth && +item.type === 1" :key="index">
                            <img class="img-box" :src="item.icon" alt="">
                            <div class="txt-box">
                                <h4 class="tit">{{item.title}}</h4>
                                <p class="desc">{{ item.subTitle }}</p>
                            </div>
                        </div>
                        <div class="item-box" v-else-if="isChsiAuth" :key="index+1">
                            <img class="img-box" :src="item.icon" alt="">
                            <div class="txt-box">
                                <h4 class="tit">{{item.title}}</h4>
                                <p class="desc">{{ item.subTitle }}</p>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="bottom" v-if="!isChsiAuth">
                <p class="tip">完善学籍信息，继续解锁以下权益</p>
                <div class="list-box lock-status">
                    <template v-for="(item, index) in data" >
                        <div class="item-box" v-if="+item.type === 2" :key="index">
                            <img class="img-box" :src="item.greyIcon" alt="">
                            <div class="txt-box">
                                <h4 class="tit">{{item.title}}</h4>
                                <p class="desc">{{ item.subTitle }}</p>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="btn-box" v-if="isShowBtn">
            <button class="btn" @click="btnClick">{{isChsiAuth ? '去看看' : '完善学籍信息'}}</button>
        </div>
    </van-popup>
</template>

<script>
import { Popup, Toast, Icon } from 'vant';

export default {
    name: 'rulePopup',
    props: {
        title: {
            type: String,
            default: ''
        },
        data: {
            type: Array,
            default: () => []
        },
        isShowBtn: {
            type: Boolean,
            default: false
        },
        isChsiAuth: { // 是否学信网认证
            type: Boolean,
            default: false
        }
    },
    components: {
        [Popup.name]: Popup,
        [Icon.name]: Icon
    },
    data() {
        return {
            showPop: false,
            rightsList: [ // mock数据
                {
                    icon: 'https://file.40017.cn/appresource/image/forStudent/new/bg_header@2x.png',
                    greyIcon: 'https://file.40017.cn/appresource/image/forStudent/new/img_close@2x.png',
                    type: '1',
                    title: '机火单单返现',
                    subTitle: '最高返40元'
                },{
                    icon: 'https://file.40017.cn/appresource/image/forStudent/new/bg_header@2x.png',
                    greyIcon: 'https://file.40017.cn/appresource/image/forStudent/new/img_close@2x.png',
                    type: '2',
                    title: '千元出行学生卡',
                    subTitle: '最高返40元'
                },{
                    icon: 'https://file.40017.cn/appresource/image/forStudent/new/bg_header@2x.png',
                    greyIcon: 'https://file.40017.cn/appresource/image/forStudent/new/img_close@2x.png',
                    type: '1',
                    title: '出行省钱学生卡',
                    subTitle: '最高返40元'
                },{
                    icon: 'https://file.40017.cn/appresource/image/forStudent/new/bg_header@2x.png',
                    greyIcon: 'https://file.40017.cn/appresource/image/forStudent/new/img_close@2x.png',
                    type: '2',
                    title: '机酒火学生价',
                    subTitle: '最高返40元'
                },{
                    icon: 'https://file.40017.cn/appresource/image/forStudent/new/bg_header@2x.png',
                    greyIcon: 'https://file.40017.cn/appresource/image/forStudent/new/img_close@2x.png',
                    type: '2',
                    title: '机火单单返现',
                    subTitle: '最高返40元'
                },{
                    icon: 'https://file.40017.cn/appresource/image/forStudent/new/bg_header@2x.png',
                    greyIcon: 'https://file.40017.cn/appresource/image/forStudent/new/img_close@2x.png',
                    type: '2',
                    title: '机学生价',
                    subTitle: '最高返40元'
                },{
                    icon: 'https://file.40017.cn/appresource/image/forStudent/new/bg_header@2x.png',
                    greyIcon: 'https://file.40017.cn/appresource/image/forStudent/new/img_close@2x.png',
                    type: '2',
                    title: '机现',
                    subTitle: '最高返40元'
                }
            ]
        }
    },
    methods: {
        show(chsiAuth) {
            this.showPop = true
            this.$emit('setTrack', {
                action: chsiAuth ? 'xuexin_rzlayer_show' : 'basic_rzlayer_show',
                label: chsiAuth ? '学信学生认证浮层曝光' : '基础学生认证浮层曝光',
                value: ''
            })
        },
        btnClick() {
            this.$emit('setTrack', {
                action: this.isChsiAuth ? 'xuexin_rzlayer_click' : 'basic_rzlayer_click',
                label: this.isChsiAuth ? '学信学生认证浮层点击' : '基础学生认证浮层点击',
                value: {"channel":"学生专区","scene":"公共","site":"按钮"}
            })
            if (this.isChsiAuth) {
                this.showPop = false
            } else {
                //去学籍认证页面，返回后刷新页面，需要显示成功弹窗
                sessionStorage.setItem('gotoStudentChsiAuth', 1)
                // 测试环境：https://wx.qa.17u.cn/memberft/student/studentcard/studentAuth?channelcode=3e5e56bc5665477bae5620ad22d878bb&certificationSource=1&refid=123
                // 线上环境：https://wx.17u.cn/memberft/student/studentcard/studentAuth?channelcode=4da9db38ad494cb98f4e5efe15ef8eec&certificationSource=1&refid=123
                const AuthUrl = process.env.VUE_APP_ENV === 'production' 
                ? 'tctclient://web/share?type=wxMiniProgram&wxUserName=gh_0a00573ff7cf&wxPath=%2Fpage%2Fhome%2Fwebview%2Fwebview%3Fsrc%3Dhttps%253A%252F%252Fwx.17u.cn%252Fmemberft%252Fstudent%252Fstudentcard%252FstudentAuth%253Fchannelcode%253D4da9db38ad494cb98f4e5efe15ef8eec%2526certificationSource%253D1%2526refid%253D2000025136'
                : 'tctclient://web/share?type=wxMiniProgram&wxUserName=gh_0a00573ff7cf&wxPath=%2Fpage%2Fhome%2Fwebview%2Fwebview%3Fsrc%3Dhttps%253A%252F%252Fwx.qa.17u.cn%252Fmemberft%252Fstudent%252Fstudentcard%252FstudentAuth%253Fchannelcode%253D3e5e56bc5665477bae5620ad22d878bb%2526certificationSource%253D1%2526refid%253D123'
                location.href = AuthUrl
            }
        },
        closePop() {
            this.showPop = false
            this.$emit('setTrack', {
                action: this.isChsiAuth ? 'xuexin_rzlayer_click' : 'basic_rzlayer_click',
                label: this.isChsiAuth ? '学信学生认证浮层点击' : '基础学生认证浮层点击',
                value: {"channel":"学生专区","scene":"公共","site":"其他"}
            })
        }
    }

}
</script>

<style lang="less" scoped>
.rule-popup-box {
    background: #F6F8FB url(//file.40017.cn/appresource/image/forStudent/new/bg_popup_top@2x.png) no-repeat;
    background-size: contain;
    border-radius: 12px 12px 0 0;
    padding-bottom: calc(12px + constant(safe-area-inset-bottom));
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
    ::v-deep .van-popup__close-icon {
        position: absolute;
        .van-icon__image {
            width: 24px;
            height: 24px;
        }
    }
    .title-popup {
        // text-align: center;
        line-height: 28px;
        font-size: 19px;
        color: #333333;
        padding-top: 16px;
        font-weight: 600;
        padding-left: 24px;
    }
    .cont-box {
        padding: 12px;
        .top, .bottom {
            background: #FFFFFF;
            border-radius: 8px;
            padding: 12px 12px 4px;
            margin-bottom: 8px;
        }
        .tip {
            font-weight: 600;
            font-size: 16px;
            color: #333333;
            margin: 0 0 12px;
        }
        .list-box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            margin: 12px 0 0;
            color: #333333;
            font-size: 14px;
            line-height: 1.5;
            padding: 0 0 0 8px;
            .item-box {
                width: 50%;
                display: flex;
                align-items: center;
                margin-bottom: 12px;
                .img-box {
                    width: 36px;
                    height: 36px;
                    border-radius: 22px;
                    margin-right: 8px;
                }
                .txt-box {
                    max-width: 106px;
                    .tit {
                        font-weight: 600;
                        font-size: 14px;
                        color: #333333;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis
                    }
                    .desc {
                        font-size: 12px;
                        color: #888888;
                        margin-top: 2px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis
                    }
                }
                
            }
            &.lock-status {
                .item-box {
                    .img-box {
                        opacity: 0.8;
                    }
                    .txt-box {
                        .tit {
                            color: #888888;
                        }
                        .desc {
                            color: #B2B2B2;
                        }
                    }
                }
            }
        }
    }
    .btn-box {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 0 20px;
        .btn {
            min-width: 210px;
            max-width: 291px;
            flex: 1;
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
            // border: 1px solid #06C584;
            border-radius: 22px;
            padding: 11px;
            margin: 0 4px;
            background-image: linear-gradient(90deg, #01E36D 0%, #06C584 100%);
            &.btn-empty {
                min-width: 108px;
                color: #06C584;
                border: 1px solid #06C584;
                background: #fff;
            }
        }
    }
}
</style>>
